// extracted by mini-css-extract-plugin
export default {"loadingColor":"#ff4156"};
    if(module.hot) {
      // 1788784362203
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  